
 <div>
    <!-- <div class="urlDiv" fxLayout="row wrap">
    <a class="urls" href="userProfiles/home/{{userId}}">
      Home /
    </a>

    <a  class="urls" href="/contest/all-contest">
       &nbsp;contests /
    </a>
    <a  class="urls" href="/contest/drawings">
        &nbsp;Drawings
     </a>
    </div> -->
        <div class="image-div" fxLayout="column wrap">
    
            <img class="image" style="height: 40vh;
            width: 100vw;" src="assets\images\contest\drawingMainBanner.jpg" alt="Banner Image">
    
        </div>   
        <div class="container">
        <p class="engageTitle" (click)="getPoints(userId)"><strong>Open drawings</strong></p> 

        <div class="card-container">
            <div class="custom-card" *ngFor="let draw of drawings">
              <div class="custom-card-header">
                <img class="img" id="imgOpen"*ngIf="!draw.isClosed" [src]="draw.recommendImageUrl"(click)="getDrawingInfo(draw.id,$event);routeToPage(draw)">
                <span  style="cursor: pointer;"*ngIf="!draw.isClosed" (click)="getDrawingInfo(draw.id,$event);routeToPage(draw)" >{{draw.name}}</span>
              </div>
            </div>
          </div>    
          <p class="engageTitle" style="float:left"><strong>Archived drawings</strong></p> <br>
 
          <div class="card-container1" style="margin-top: 3%;">
            <div class="custom-card" *ngFor="let draw of drawings">
              <div class="custom-card-header">
                <img class="img" id="imgArchieve" *ngIf="draw.isClosed" [src]="draw.recommendImageUrl"(click)="getDrawingInfo(draw.id,$event)">
                <span style="cursor: pointer;" *ngIf="draw.isClosed" (click)="getDrawingInfo(draw.id,$event)">{{draw.name}}</span>
              </div>
            </div>     
          </div>     

        </div>     
        
          
        <!-- <div class="container">

         
      <br>
      
      <div    >
      
           <div class="movie-banner" *ngFor="let draw of drawings">
            <img class="imgBanner"  [src]="draw.recommendImageUrl">
            <div class="names">
                <span  *ngIf="draw.isClosed" >{{draw.name}}</span>
            </div>
           
          </div> 
        
       </div>
        </div> -->
      </div>
